import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { billingPipelineUiEnabled } from 'src/constants/config';
import { canSyncInvoice } from 'src/pages/billing/utils/billing-utils';
import { ReduxState } from 'src/redux/redux-state';

type BillingPipelineRouteGuardProps = {
  readonly children: ReactNode;
};

/**
 * Pipeline operator UI: feature flag + billing_admin only.
 */
export function BillingPipelineRouteGuard({ children }: BillingPipelineRouteGuardProps) {
  const groups = useSelector((s: ReduxState) => s.userState.permissions?.groups ?? []);
  const isBillingAdmin = canSyncInvoice(groups);

  if (!billingPipelineUiEnabled) {
    return (
      <Navigate
        to="/billing"
        replace
      />
    );
  }
  if (!isBillingAdmin) {
    return (
      <Navigate
        to="/billing"
        replace
      />
    );
  }

  return (
    <>
      {children}
    </>
  );
}
